import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const GET_BLOGS_REQUEST = "GET_BLOGS_REQUEST";
export const GET_BLOGS_SUCCESS = "GET_BLOGS_SUCCESS";
export const GET_BLOGS_FAILURE = "GET_BLOGS_FAILURE";

export const GET_BLOGS_DETAILS_REQUEST = "GET_BLOGS_DETAILS_REQUEST";
export const GET_BLOGS_DETAILS_SUCCESS = "GET_BLOGS_DETAILS_SUCCESS";
export const GET_BLOGS_DETAILS_FAILURE = "GET_BLOGS_DETAILS_FAILURE";

export const getBlogs = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_BLOGS_REQUEST });
      const url = `${BASE_URL}/blog/get/blogs/v1`;
      const response = await axios.get(url);
      dispatch({ type: GET_BLOGS_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: GET_BLOGS_FAILURE, payload: error.message });
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
};

export const getBlogsDetails = (_id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_BLOGS_DETAILS_REQUEST });
      const url = `${BASE_URL}/blog/get/blog/details/${_id}/v1`;
      const response = await axios.get(url);
      dispatch({ type: GET_BLOGS_DETAILS_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: GET_BLOGS_DETAILS_FAILURE, payload: error.message });
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
};
